import { FC, useCallback, useState } from 'react';
import { Box, Menu, SxProps } from '@mui/material';
import { useWatch, Control } from 'react-hook-form';

import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrowDown.svg';
import { CommonButton } from 'components/CommonButton';
import { RadioGroupController } from 'components/RadioGroupController';
import { RadioGroupItem } from 'components/RadioGroupController/types';

import { styles } from './styles';

export const useSelectInput = (control: Control, controlName: string) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = !!anchorEl;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const currentVal = useWatch({
    control,
    name: controlName,
  });

  return {
    anchorEl,
    currentValue: currentVal,
    open,
    handleClick,
    handleClose,
  };
};

interface SelectInputProps {
  data: RadioGroupItem[];
  control: Control;
  controlName: string;
  placeHolder?: string;
  sx?: SxProps;
  menuSx?: SxProps;
}

export const SelectInput: FC<SelectInputProps> = ({
  placeHolder = '',
  data,
  control,
  controlName,
  sx = {},
  menuSx = {},
}) => {
  const { anchorEl, open, handleClick, handleClose } = useSelectInput(control, controlName);
  const value = useWatch({
    control,
    name: controlName,
  });

  return (
    <>
      <CommonButton
        sx={{
          ...styles.menuButton,
          ...(open && styles.menuButtonOpened),
          ...sx,
        }}
        onClick={handleClick}
        disableRipple
      >
        {value || placeHolder}
        <Box
          sx={{
            ...styles.menuButtonIcon,
            ...(open && styles.menuButtonIconopened),
          }}
        >
          <ArrowDownIcon />
        </Box>
      </CommonButton>
      <Menu
        sx={{ ...styles.menuWrap, ...menuSx }}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: -8,
          horizontal: 'left',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <RadioGroupController controlName={controlName} control={control} data={data} handleClose={handleClose} />
      </Menu>
    </>
  );
};
